/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
	// Add custom code below this line

	// Klaviyo Free Ebook Form
	document.querySelectorAll('.ebook__container[data-klaviyo-form]').forEach((link) => {
		link.addEventListener('click', function (e) {
			e.preventDefault();

			const formId = link.getAttribute('data-klaviyo-form');

			if (!formId) return;

			window._klOnsite = window._klOnsite || [];
			window._klOnsite.push(['openForm', formId]);
		});
	});
	// ^^ Keep your scripts inside this IIFE function call to
	// avoid leaking your variables into the global scope.
})();
